import { cn } from "@/lib/utils";

interface CountPillProps {
  count: number | string;
  active?: boolean;
  className?: string;
}

export function CountPill({ count, active = false, className }: CountPillProps) {
  return (
    <span
      className={cn(
        // `align-middle` keeps the pill's vertical centre aligned with the
        // x-height midpoint of the surrounding text, so it reads as centred
        // whether the parent is plain inline flow (h1/h2/div text) or a
        // flex/inline-flex container (TabsTrigger, Button).
        "ml-2 inline-flex items-center justify-center align-middle min-w-[1.25rem] h-5 px-1.5 rounded-full text-[10px] font-semibold leading-none transition-colors",
        active ? "bg-foreground/15 text-foreground" : "bg-muted text-muted-foreground",
        className,
      )}
    >
      {count}
    </span>
  );
}
